var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStroller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3860_2195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 3.08022V10.0002H21C21 5.97022 18.02 2.63022 14.14 2.08022C13.54 1.99022 13 2.47022 13 3.08022ZM19.32 15.8902C20.37 14.5402 21 12.8402 21 11.0002H6.44L5.76 9.57022C5.6 9.22022 5.24 9.00022 4.86 9.00022H3C2.45 9.00022 2 9.45022 2 10.0002C2 10.5502 2.45 11.0002 3 11.0002H4.22C4.22 11.0002 6.11 15.0702 6.34 15.4202C5.01 16.1302 4.2 17.6902 4.6 19.3602C4.9 20.6202 5.94 21.6302 7.2 21.9102C9.3 22.3702 11.18 20.9502 11.45 19.0002H13.53C13.8 20.9402 15.67 22.3602 17.75 21.9202C19.02 21.6502 20.06 20.6502 20.38 19.3902C20.73 18.0002 20.24 16.7102 19.32 15.8902ZM8 20.0002C7.17 20.0002 6.5 19.3302 6.5 18.5002C6.5 17.6702 7.17 17.0002 8 17.0002C8.83 17.0002 9.5 17.6702 9.5 18.5002C9.5 19.3302 8.83 20.0002 8 20.0002ZM17 20.0002C16.17 20.0002 15.5 19.3302 15.5 18.5002C15.5 17.6702 16.17 17.0002 17 17.0002C17.83 17.0002 18.5 17.6702 18.5 18.5002C18.5 19.3302 17.83 20.0002 17 20.0002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3860_2195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroller);
export default __webpack_public_path__ + "static/media/stroller.6f1f2512ccb6dcc2728c95336134c0bc.svg";
export { ForwardRef as ReactComponent };